import { Box, ClassNameMap, Container, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useMemo } from 'react';
import { ProviderLayoutPageTitle } from './ProviderLayoutPageTitle.component';
import { ProviderLayoutJumpNavProps } from './ProviderLayoutJumpNav.component';

export type ProviderLayoutPageHeaderProps = {
  divider?: boolean;
  title: React.ReactNode;
  actions?: React.ReactNode;
  jumpNav?: React.ReactElement<ProviderLayoutJumpNavProps>;
  classes?: Partial<ClassNameMap<'content' | 'actions'>>;
};

export const ProviderLayoutPageHeader: React.FC<ProviderLayoutPageHeaderProps> = props => {
  const { classes, cx } = useProviderLayoutPageHeaderStyles(props, { props });

  const content = useMemo(() => {
    if (typeof props.title === 'string') {
      return <ProviderLayoutPageTitle title={props.title} />;
    }

    return props.title;
  }, [ props.title ]);

  return (
    <>
      <Box className={classes.root}>
        <Container className={classes.container}>
          <Box
            className={cx(classes.content, {
              [classes.alignCenter]: typeof props.title === 'string',
            })}
          >
            <Box flex={1}>
              {content}
            </Box>
            <Box className={classes.actions}>
              {props.actions}
            </Box>
          </Box>
          {props.jumpNav && <Divider />}
        </Container>
        {props.children}
      </Box>
      {props.jumpNav}
    </>
  )
  ;
};

const useProviderLayoutPageHeaderStyles = makeStyles<Partial<ProviderLayoutPageHeaderProps>>({ name: 'ProviderLayoutPageHeader' })(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flexWrap: 'wrap',

    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(3),
  },
  alignCenter: {
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  }
}));
